export const sumRow = (
  rows: Array<Record<string, string | number>>,
  columns: Array<{ field: string; summable?: boolean }>,
) => {
  const tmpObj: Record<string, string | number> = {};
  Object.keys(rows[0]).forEach(function (key: string) {
    if (key === "id") {
      tmpObj[key] = "sum-999999";
    } else if (key === columns[0].field) {
      tmpObj[key] = "Total";
    } else if (
      columns.find((column) => column.field === key && column.summable)
    ) {
      let tot = 0;
      Object.keys(rows).forEach(function (rowKey) {
        const idx = Number(rowKey);
        tot += Number(rows[idx][key] as number) || 0;
      });

      tmpObj[key] = tot;
    } else {
      tmpObj[key] = "";
    }
  });
  return [tmpObj];
};
